import isEmpty from 'lodash/isEmpty';
import { GetStaticProps, NextPage } from 'next';
import React from 'react';

import HeadMeta from '@/components/static-pages/HeadMeta';
import SitemapTemplate from '@/components/templates/SitemapTemplate';
import { getStaticPageData } from '@/services/getPageData';
interface IContentBlock {
  type: string;
  value: {
    collapsed_initially: boolean;
    collapsed_text: string;
    displayed_text: string;
  };
}

export interface ISitemapProps {
  seoTitle: string;
  seoDescription: string;
  title: string;
  contentBlocks: IContentBlock[];
  noindex: boolean;
}

const Sitemap: NextPage<ISitemapProps> = props => {
  return (
    <>
      <HeadMeta title={props.seoTitle} description={props.seoDescription} noindex={props.noindex} />
      <SitemapTemplate {...props} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const pageData = await getStaticPageData({ locale, url_path: 'sitemap' });
  if (isEmpty(pageData) || isEmpty(pageData.metadata)) {
    return { notFound: true, revalidate: true };
  }

  const { seo_title, seo_description, title, content_blocks } = pageData.metadata;

  return {
    props: {
      seoTitle: seo_title,
      seoDescription: seo_description,
      title,
      contentBlocks: content_blocks,
      noindex: !!pageData.fallback,
    },
  };
};

export default Sitemap;
